export function getTags(search: string | undefined): Array<string> {
  if (!search) return [];
  const searchParams = new URLSearchParams(search);
  return searchParams.getAll("tags")?.at(0)?.split(",") || [];
}
